<template>
    <div class="col-sm-12 nopads mt-2">
        <div class="px-3 pb-3">
            <div class="col-sm-12 search-form-title">
                <font-awesome-icon icon="search" />
                {{ $t('common.search') }}
            </div>
            <div class="no-margin">
                <div class="row px-1">
                    <div class="col-sm-3 px-2">
                        <span class="span-title">
                            {{ $t('ins_report.from_date') }}
                        </span>
                        <date-time-picker
                            v-model:date="fromDate"
                            class="routa-input"
                            format="dd.MM.yyyy HH:mm"
                            :enable-time-picker="true"
                            :placeholder="$t('areas.set_work_time')"
                        />
                    </div>

                    <div class="col-sm-3 px-2">
                        <span class="span-title">
                            {{ $t('ins_report.to_date') }}
                        </span>
                        <date-time-picker
                            v-model:date="toDate"
                            class="routa-input"
                            format="dd.MM.yyyy HH:mm"
                            :enable-time-picker="true"
                            :placeholder="$t('areas.set_work_time')"
                        />
                    </div>
                    <div
                        class="col-sm-6"
                        style="margin-top: .4em"
                    >
                        <open-contract-filter
                            ref="contracts"
                            :to="toDate"
                            :from="fromDate"
                            :show-company="false"
                            :show-only-my-contracts-option="true"
                            :show-title="true"
                            :only-ely="true"
                            :required="true"
                            @loading="loading = true"
                            @loading-completed="loading = false"
                            @contract-selected="setContract"
                        />
                    </div>
                </div>

            </div>
            <div class="col-sm-12 button-container">
                <button
                    class="btn btn-danger form-button"
                    @click.stop="onReset"
                >
                    {{ $t('ins_report.clear') }}
                </button>
                <button
                    type="submit"
                    class="btn btn-primary form-button"
                    :disabled="!fromDate || !contract"
                    @click.stop="onSubmit"
                >
                    {{ $t('ins_report.search') }}
                </button>
            </div>
        </div>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import { restApi } from '../../mixins/RestApiMixin'
import { timeUtils } from '../../mixins/TimeUtils'
import { contractHelper } from "@/components/mixins/ContractMixin";
import OpenContractFilter from "@/components/contract/OpenContractFilter.vue";
import DateTimePicker from "@/components/common/DateTimePicker";

export default {
    name: 'SpreaderRestrictionAreaSearch',
    components: {
        OpenContractFilter,
        DateTimePicker
    },
    mixins: [restApi, timeUtils, contractHelper],
    data: function () {
        return {
            fromDate: '',
            toDate: '',
            contract: null,
            loading: false,
        }
    },

    mounted: function () {
        this.fromDate = this.preSelectedContract ? this.getDayStart() : this.getMonthStart()
    },
    methods: {
        setContract: function (contract) {
            this.contract = contract
        },

        onReset: function () {
            this.contract = null
            this.fromDate = this.getMonthStart()
            this.toDate = ''
            this.$refs.contracts.resetSelection()
        },

        getOptionSearchParams() {
            return {
                from: this.fromDate,
                to: this.toDate,
                contract: this.contract?.id,
            }
        },

        onSubmit: function () {
            var params = {}
            params.contract = this.contract.id
            params.from = this.fromDate
            params.to = this.toDate
            this.$emit('search', params)
        }
    }
}
</script>

<style scoped></style>
